import { Controller } from "@hotwired/stimulus";
import OperatingSystemParser from "device-detector-js/dist/parsers/operating-system";

/*
 * Parses the browser user agent to discover operating system and
 * architecture (platform).
 *
 * Items must have data-operating-system-item-os-value and
 * data-operating-system-item-arch-value attributes matching the values
 * detected by device-detector-js.
 *
 * data-operating-system-item-class-hide-value and
 * data-operating-system-item-class-show-value indicate which class
 * (single) should be used to hide/show items.
 *
 * If all items end up hidden, the first one is shown again.
 *
 * This controller doesn't allow to add items on the fly, because it
 * needs to show at least an item if nothing matches.
 *
 * @see {templates/macros/download_header_dropdown_button.html}
 */
export default class extends Controller {
  static targets = ["item"];

  get parser() {
    if (!this._parser) {
      this._parser = new OperatingSystemParser();
    }

    return this._parser;
  }

  get device() {
    if (!this._device) {
      this._device = this.parser.parse(window.navigator.userAgent);
    }

    return this._device;
  }

  connect() {
    for (const itemTarget of this.itemTargets) {
      const {
        operatingSystemItemOsValue,
        operatingSystemItemArchValue,
        operatingSystemItemClassHideValue,
        operatingSystemItemClassShowValue,
      } = itemTarget.dataset;

      const matches =
        this.device.name === operatingSystemItemOsValue &&
        this.device.platform == operatingSystemItemArchValue;

      if (operatingSystemItemClassHideValue) {
        itemTarget.classList[matches ? "remove" : "add"](
          operatingSystemItemClassHideValue,
        );
      }
      if (operatingSystemItemClassShowValue) {
        itemTarget.classList[matches ? "add" : "remove"](
          operatingSystemItemClassShowValue,
        );
      }
    }

    const atLeastOneVisible = this.itemTargets.some(
      (x) => !x.classList.contains(x.dataset.operatingSystemItemClassHideValue),
    );

    if (atLeastOneVisible) return;

    const firstItemTarget = this.itemTargets[0];

    firstItemTarget.classList.remove(
      firstItemTarget.dataset.operatingSystemItemClassHideValue,
    );
  }
}
